import { useDispatch } from 'react-redux';

import { MainStoreDispatch } from 'modules/main/store/MainStoreDispatch';

export const useMainDispatch: () => MainStoreDispatch = useDispatch;
